import React, { useEffect } from "react";
import { useState, useRef } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import $ from "jquery";

import Cookies from 'js-cookie';
import { config } from "../../api/api";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MotorRenewSearchPage = () => {
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    
      const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const selectOpt1 = useRef(null);
  const [errors, setErrors] = useState({});
  const base_url = config.baseURL;
  const vendor_key =
    "yeflesxnwar1xh31o6pg4ww9fr03ohn74u4h6oy0xx4qpzot0aqbhwlhbiv55k0qf1bls12v7zrlhriuu77wcytijxdzvfrfnxlhq68y30eiy59ok01iyn1xzyangrew9w19cchvd62js5164j4bmfcauj3vc7qkpqkjdl7hdpzxc2xzoq35ehuq3gzybhh1rc3v6tr5slr2ivv958ixq35k5meh3626v3g9sckyp267o8vup7kd72ntp9udknjz";

  const plateNoRef = useRef(null);
  const registrationMarkRef = useRef(null);
  const civilIdRef = useRef(null);
  const mobileNoRef = useRef(null);
  const quoteNoRef = useRef(null);
  const [message, setMessage] = useState(null);
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [userData, setUserData] = useState();


  const [formData, setFormData] = useState({
    plateNo: "",
    registrationMark: "",
    civilId: "",
    mobileNo: "",
    quoteNo: "",
  });

   const reg_mark =  [
  "A","A A","A B","A D","A K","A M","A R","A S","A W","A Y",
  "Abu Dhabi","Ajman",
  "B","B A","B B","B D","B H","B K","B M","B R","B S","B W","B Y",
  "Bahrain","BANK",
  "C D",
  "D","D A","D D","D H","D K","D R","D S","D W","D Y",
  "Dubai",
  "Fujairah",
  "H","H A","H D","H H","H K","H M","H R","H S","H W","H Y",
  "I N T L","IMPORT","Inspection",
  "J",
  "K","K A","K B","K H","K K",
  "KSA","Kuwait",
  "L A","L A","L B","L D","L H","L K",
  "M","M A","M B","M D","M H","M K","M L","M M","M R","M S","M W","M Y","MUSCAT",
  "Qatar",
  "R","R A","R H","R K","R M","R R","R S","R W","R Y","Ras Al - Khaimah",
  "S","S H","S S",
  "Sharjah",
  "T","T A","T B","T B A","T D","T H","T T",
  "UAE","Umm Al - Quwain",
  "W","W A","W B","W K","W W",
  "Y","Y A","Y B","Y D","Y M","Y R","Y S","Y W","Y Y",
  "1","2","3","4","5","6","7","8","9",
  "10","11","12","14","15","16","17","18","19",
  "20","21","22","23","24","25","26","27","28","29",
  "30","31","32","33","34","35","36","37","38","39",
  "40","41","42","43","44","45","46","47","48","49",
  "50","51","52","53","54","55","56","57","58","59",
  "60","61","62","63","64","65","66","67","68","69",
  "70","71","72","73","74","75","76","77","78","79",
  "80","81","82","83","84","85","86","87","88","89",
  "90","91","92","999"
];

  const [allow,setAllow]=  useState(false);

     useEffect(()=>{
             const getBasicInfo=sessionStorage.getItem("motorBasicDetails");
             if(!getBasicInfo){
                window.location.href="/motor-insurance-page"
             }
             else{
              setAllow(true);
             }
          },[])



  const handleValidationRegMark = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    // if (!value || value == null) {
    //   setErrors((prev) => ({
    //     ...prev,
    //     [name]: name +" is required",
    //   }));
    // } else {
    //   setErrors((prev) => ({ ...prev, [name]: "" }));
    // }
  };

  useEffect(() => {
    const $select = $(selectOpt1.current);

    // Initialize Select2

    $select.select2({ width: "100%" });
     $select.select2({
        width: "100%",
        matcher: function(params, data) {
          if ($.trim(params.term) === "") {
            return data;
          }
    
          const search = params.term.replace(/\s+/g, "").toLowerCase();
          const text = (data.text || "").replace(/\s+/g, "").toLowerCase();
    
          if (text.indexOf(search) > -1) {
            return data;
          }
          return null;
        }
      });

    // Define event handlers
    const handleSelect = (e) => {
      //  debugger
      const selectedValue = e.params.data.id;
      handleValidationRegMark("registrationMark", selectedValue);
    };

    // if (formData.passport_country) {
    //   $select.val(formData.passport_country).trigger("change");
    // }

    // Attach handlers
    $select.on("select2:select", (e) => handleSelect(e));

    // Cleanup
    return () => {
      $select.off("select2:select", handleSelect);
      $select.select2("destroy");
    };
  }, [reg_mark]);

  const handleClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  useEffect(() => {
    setActiveButton(1);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const trimValue = value.trimStart();
    const numberFields = ["plateNo", "civilId", "mobileNo"];
    const numberRegex = /^[0-9]*$/;

    if (numberFields.includes(name)) {
      if (numberRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
    } else {
      setFormData({ ...formData, [name]: trimValue });
    }
  };

  const formValidation1 = (e) => {
    let newErrors = {};
    if (!formData.plateNo) {
      newErrors.plateNo1 = "plate No is Required";
    }
    if (!formData.registrationMark || formData.registrationMark.includes("--")) {
      newErrors.registrationMark1 = "plate Code is Required";
    }
    if (!formData.civilId) {
      newErrors.civilId = "civil Id is Required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      switch (firstErrorField) {
        case "plateNo1":
          plateNoRef.current.focus();
          break;
        case "registrationMark1":
          registrationMarkRef.current.focus();
          break;
        case "civilId":
          civilIdRef.current.focus();
          break;
        default:
          break;
      }
      return false;
    }
    return Object.keys(newErrors).length === 0;
  };

  const formValidation2 = (e) => {
    let newErrors = {};

    if (!formData.plateNo) {
      newErrors.plateNo2 = "plate No is Required";
    }
    if (!formData.registrationMark || formData.registrationMark.includes("--") ) {
      newErrors.registrationMark2 = "plate Code is Required";
    }
    if (!formData.mobileNo) {
      newErrors.mobileNo = "mobile No is Required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      switch (firstErrorField) {
        case "plateNo2":
          plateNoRef.current.focus();
          break;
        case "registrationMark2":
          registrationMarkRef.current.focus();
          break;
        case "mobileNo":
          mobileNoRef.current.focus();
          break;
        default:
          break;
      }
      return false;
    }
    return Object.keys(newErrors).length === 0;
  };

  const formValidation3 = (e) => {
    let newErrors = {};

    if (!formData.quoteNo) {
      newErrors.quoteNo = "quote No is Required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      switch (firstErrorField) {
        case "quoteNo":
          quoteNoRef.current.focus();
          break;

        default:
          break;
      }
      return false;
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleValidation = (e) => {
    const { name } = e.target;
    const value = (formData[name] ?? "").toString().trim();

    if (value) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
     useEffect(() => {
          const storedUserString = Cookies.get('userData');
          if (storedUserString !== undefined) {
            const user_data = JSON.parse(storedUserString);
          
            setUserData(user_data);
            
            
          } else {
          //   alert('Login Session Expired');
          //   window.location.href = '/';
          }
      
        }, []);

  const search_quote = async (payload) => {
    try {

       if(userData && userData.access_token){

        if(userData.type==="staff"){
          payload["user_type"]="staff";
        }
        else if(userData.agency_name){
         payload["user_type"]="agent";
        }
        else if(userData.first_name){
         payload["user_type"]="user";
        }
         payload["token"]=userData.access_token;
      }

      const response = await fetch(base_url + "/motor_search_quote", {
        method: "POST",
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + vendor_key,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("API request failed");

      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch data", error);
    }
  };

  const handleClose = () => {
    setOpenMessageBox(false);
  };

  const handleGetQuote = async () => {
  
    if (activeButton === 1) {
      if (!formValidation1()) return;
        setLoading(true)
      const payload = {
        plateNo: formData.plateNo,
        registrationMark: formData.registrationMark,
        civilId: formData.civilId,
        srcBusId: "SJET",
        txnTyp: "Q",
        mobileNo: "",
        policyNo: "",
        policy_type:"renewal"
      };
      const quoteDetails = await search_quote(payload);
      debugger;
      console.log(quoteDetails);
      if (
        quoteDetails.result.effectiveDt &&
        quoteDetails.result.insuredDetails &&
        quoteDetails.result.vehicleDetails
      ) {
        setLoading(false);
              const quoteNo={
                quoteNo:quoteDetails.result.transactionDetails.quoteNo || quoteDetails.result.renewalQuoteNo
              }
        sessionStorage.setItem("motorQuoteNo",JSON.stringify(quoteNo));
        navigate("/motor-ins-quote-summary");
      } else if (quoteDetails.result.transactionDetails.errMsg) {
         setLoading(false);
        setMessage(quoteDetails.result.transactionDetails.errMsg);
        setOpenMessageBox(true);
      }
    }

    if (activeButton === 2) {
      if (!formValidation2()) return;
      const payload = {
        plateNo: formData.plateNo,
        registrationMark: formData.registrationMark,
        civilId: "",
        srcBusId: "SJET",
        txnTyp: "Q",
        mobileNo: formData.mobileNo,
        policyNo: "",
        policy_type:"renewal"
      };
      const quoteDetails = await search_quote(payload);
      console.log(quoteDetails);
      if (
        quoteDetails.result.effectiveDt &&
        quoteDetails.result.insuredDetails &&
        quoteDetails.result.vehicleDetails
      ) {
         setLoading(false);
              const quoteNo={
                quoteNo:quoteDetails.result.transactionDetails.quoteNo || quoteDetails.result.renewalQuoteNo
              }
        sessionStorage.setItem("motorQuoteNo",JSON.stringify(quoteNo));
        navigate("/motor-ins-quote-summary");
      } else if (quoteDetails.result.transactionDetails.errMsg) {
         setLoading(false);
        setMessage(quoteDetails.result.transactionDetails.errMsg);
        setOpenMessageBox(true);
      }
    }

    if (activeButton === 3) {
      if (!formValidation3()) return;
      const payload = {
        civilId: "",
        plateNo: "",
        registrationMark: "",
        srcBusId: "SJET",
        txnTyp: "Q",
        mobileNo: "",
        policyNo: "",
        quoteNo: formData.quoteNo,
        searchTyp: "",
        policy_type:"renewal"
      };
      const quoteDetails = await search_quote(payload);
      console.log(quoteDetails);
      if (
        quoteDetails.result.effectiveDt &&
        quoteDetails.result.insuredDetails &&
        quoteDetails.result.vehicleDetails
      ) {
         setLoading(false);
         const quoteNo={
                quoteNo:quoteDetails.result.transactionDetails.quoteNo || quoteDetails.result.renewalQuoteNo
              }
        sessionStorage.setItem("motorQuoteNo",JSON.stringify(quoteNo));
        navigate("/motor-ins-quote-summary");
      } else if (quoteDetails.result.transactionDetails.errMsg) {
         setLoading(false);
        setMessage(quoteDetails.result.transactionDetails.errMsg);
        setOpenMessageBox(true);
      }
    }
  };

  return (
    <>
     {allow &&
     <> 
      <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t("Renew Policy")}</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container  mt-3">
          <div className="row d-flex justify-content-center">
            <div className=" rounded col-md-6 p-3 mt-3">
              <div className="col-md-12 d-flex  p-0">
                <button
                  className="col-md-4"
                  style={{
                    padding: "10px 10px",
                    border: "1px solid #3fd2f2",
                    borderRadius: "6px 0px 0px 6px",
                    backgroundColor: activeButton === 1 ? " #3fd2f2" : "white",
                    color: activeButton === 1 ? " white" : "#3fd2f2",
                  }}
                  onClick={() => handleClick(1)}
                >
                  <div>{t("Plate & Civil id")}</div>
                </button>
                <button
                  className="col-md-4"
                  style={{
                    padding: "10px 10px",
                    border: "1px solid #3fd2f2",
                    borderRadius: "0px 0px 0px 0px",
                    backgroundColor: activeButton === 2 ? " #3fd2f2" : "white",
                    color: activeButton === 2 ? " white" : "#3fd2f2",
                  }}
                  onClick={() => handleClick(2)}
                >
                  <div>{t("Plate & Mobile No")}</div>
                </button>
                <button
                  className="col-md-4"
                  style={{
                    padding: "10px 10px",
                    border: "1px solid #3fd2f2",
                    borderRadius: "0px 6px 6px 0px",
                    backgroundColor: activeButton === 3 ? " #3fd2f2" : "white",
                    color: activeButton === 3 ? " white" : "#3fd2f2",
                  }}
                  onClick={() => handleClick(3)}
                >
                  <div>{t("Quote No")}</div>
                </button>
              </div>

              {activeButton == 1 && (
                <>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label className="mb-0 mt-1 ">
                        {t("Plate Number")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="plateNo"
                        value={formData.plateNo}
                        onChange={handleChange}
                        onBlur={handleValidation}
                        ref={plateNoRef}
                      />
                      {errors.plateNo1 && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.plateNo1}
                        </span>
                      )}
                    </div>

                    <div className=" col-md-6 ">
                      <label className="mb-0 mt-1 ">
                        {t("Plate Code")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-control"
                        name="registrationMark"
                        onChange={handleChange}
                        ref={selectOpt1}
                        value={formData.registrationMark}
                        onBlur={handleValidation}
                      >
                        {/* (A A) */}
                        <option style={{ fontSize: "14px" }} value={null}>
                          --{t("Select")}--
                        </option>
                        {reg_mark.map((option, index) => (
                          <option
                            style={{ fontSize: "14px" }}
                            key={index}
                            value={option}
                          >
                            {option}
                          </option>
                        ))}
                      </select>
                      {errors.registrationMark1 && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.registrationMark1}
                        </span>
                      )}
                    </div>

                    <div className=" col-md-6">
                      <label className="mb-0 mt-1 ">
                        {t("Civil ID/ License No")}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="civilId"
                        value={formData.civilId}
                        onChange={handleChange}
                        ref={civilIdRef}
                      />
                      {errors.civilId && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.civilId}
                        </span>
                      )}
                    </div>
                  </div>
                  <div>
                    <button
                      className=" mt-3  btn-primary"
                      onClick={handleGetQuote}
                    >
                      {t("GET QUOTE")}
                    </button>
                  </div>
                </>
              )}

              {activeButton == 2 && (
                <>
                  <div className="row mt-3">
                    <div className=" col-md-6 ">
                      <label className="mb-0 mt-1 ">
                        {t("Plate Number")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control  col-md-12"
                        name="plateNo"
                        value={formData.plateNo}
                        onChange={handleChange}
                        ref={plateNoRef}
                      />
                      {errors.plateNo2 && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.plateNo2}
                        </span>
                      )}
                    </div>

                    <div className=" col-md-6  ">
                      <label className="mb-0 mt-1 ">
                        {t("Plate Code")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-control"
                        name="registrationMark"
                        ref={selectOpt1}
                        value={formData.registrationMark}
                        onChange={handleChange}
                      >
                        {/* (A A) */}
                        <option style={{ fontSize: "14px" }} value={null}>
                          --{t("Select")}--
                        </option>
                        {reg_mark.map((option, index) => (
                          <option
                            style={{ fontSize: "14px" }}
                            key={index}
                            value={option}
                          >
                            {option}
                          </option>
                        ))}
                      </select>
                      {errors.registrationMark2 && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.registrationMark2}
                        </span>
                      )}
                    </div>

                    <div className=" col-md-6">
                      <label className="mb-0 mt-1 ">
                        {t("Mobile Number")}<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="mobileNo"
                        onChange={handleChange}
                        value={formData.mobileNo}
                        ref={mobileNoRef}
                      />
                      {errors.mobileNo && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.mobileNo}
                        </span>
                      )}
                    </div>
                  </div>
                  <div>
                    <button
                      className=" mt-3  btn-primary"
                      onClick={handleGetQuote}
                    >
                      {t("GET QUOTE")}
                    </button>
                  </div>
                </>
              )}
              {activeButton == 3 && (
                <div className="col-md-12 p-0 mt-3">
                  <div className=" p-0">
                    <label className="mb-0 mt-1 ">
                      {t("Quote No")}<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="quoteNo"
                      onChange={handleChange}
                      value={formData.quoteNo}
                      ref={quoteNoRef}
                    />
                    {errors.quoteNo && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.quoteNo}
                      </span>
                    )}
                  </div>
                  <div>
                    <button
                      className=" mt-3 btn-primary"
                      onClick={handleGetQuote}
                    >
                      {t("GET QUOTE")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {openMessageBox && (
            <div className="modal">
              <div
                className="modal-content"
                style={{ height: "auto", width: "600px" }}
              >
                {/* <button type="button" className="close" onClick={handleClose}>
          &times;
          </button> */}

                <div>
                  <div style={{ textAlign: "left" }}>{message}</div>

                  <hr></hr>
                  <div>
                    <button
                      type="button"
                      className="btn btn-primary mt-3"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
      </>
      }
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default MotorRenewSearchPage;
